import { render } from "./hangup.vue?vue&type=template&id=35562f96"
const script = {}

import exportComponent from "D:\\wamp\\www\\ycjx\\chat-example\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__